import React from 'react';

interface SectionHeaderProps {
    title: string;
    className?: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({title, className = ''}) => {
    return <h2 className={`text-[27px] font-medium text-mld-text-primary mb-2 ${className}`}>{title}</h2>;
};

export default SectionHeader;
